export function transformGuides(guidesList) {
  const options = [];

  for (const key in guidesList) {
    if (guidesList.hasOwnProperty(key)) {
      // Убеждаемся, что это свойство самого объекта, а не из прототипа
      const value = key; // Ключ как строка (value)
      const label = String(guidesList[key]); // Значение как строка (label)

      options.push({ value: value, label: label });
    }
  }

  return options;
}
